import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'premiumPenceUp' })
export class PremiumPenceUpPipe implements PipeTransform {
  transform(value: any, decimals: number = 2): number {
    const num = Number(value);
    if (!isFinite(num)) return 0;
    const factor = Math.pow(10, decimals);
    return Math.round(num * factor + 1e-8) / factor;
  }
}
